// Base URL for the backend API.
// In dev, CRA's "proxy" in package.json forwards /api to the server, so this can stay empty.
// In production (if you deploy client and server separately) set REACT_APP_API_URL.
const API_BASE = process.env.REACT_APP_API_URL || "";

async function request(path, options = {}) {
  const res = await fetch(`${API_BASE}${path}`, {
    credentials: "include",
    headers: options.body instanceof FormData ? undefined : { "Content-Type": "application/json" },
    ...options,
  });
  const data = await res.json().catch(() => ({}));
  if (!res.ok) {
    throw new Error(data.error || "Something went wrong. Please try again.");
  }
  return data;
}

// Adds `id` (alias of Mongo `_id`) so existing components that read `cake.id`
// keep working untouched.
function normalizeCake(cake) {
  if (!cake) return cake;
  return { ...cake, id: cake._id };
}

export const api = {
  // Cakes
  getCakes: (opts = {}) => {
    const params = new URLSearchParams(opts).toString();
    return request(`/api/cakes${params ? `?${params}` : ""}`).then((d) => ({
      cakes: (d.cakes || []).map(normalizeCake),
    }));
  },
  getCake: (id) => request(`/api/cakes/${id}`).then((d) => ({ cake: normalizeCake(d.cake) })),
  createCake: (payload) =>
    request(`/api/cakes`, { method: "POST", body: JSON.stringify(payload) }),
  updateCake: (id, payload) =>
    request(`/api/cakes/${id}`, { method: "PUT", body: JSON.stringify(payload) }),
  deleteCake: (id) => request(`/api/cakes/${id}`, { method: "DELETE" }),

  // Settings
  getSettings: () => request(`/api/settings`).then((d) => d.settings),
  updateSettings: (payload) =>
    request(`/api/settings`, { method: "PUT", body: JSON.stringify(payload) }).then(
      (d) => d.settings
    ),

  // Auth
  login: (email, password) =>
    request(`/api/auth/login`, { method: "POST", body: JSON.stringify({ email, password }) }),
  logout: () => request(`/api/auth/logout`, { method: "POST" }),
  me: () => request(`/api/auth/me`),
  changePassword: (currentPassword, newPassword) =>
    request(`/api/auth/change-password`, {
      method: "POST",
      body: JSON.stringify({ currentPassword, newPassword }),
    }),

  // Uploads
  uploadImage: (file) => {
    const body = new FormData();
    body.append("image", file);
    return request(`/api/upload`, { method: "POST", body });
  },
  deleteImage: (publicId) =>
    request(`/api/upload`, { method: "DELETE", body: JSON.stringify({ publicId }) }),
};
